import React, { useState, useEffect, useCallback } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import AppHeader from '../../Components/layout/AppHeader';
import AppSidebar from '../../Components/layout/AppSidebar';
import AppLogin from '../../Components/login/AppLogin';
import { useNavigate } from 'react-router-dom';

const SIDEBAR_COLLAPSED_KEY = 'sidebarCollapsed';
// Keep in sync with the drawer breakpoint in Components/layout/SideBar.css
const MOBILE_QUERY = '(max-width: 991px)';

function readCollapsed() {
    try {
        return localStorage.getItem(SIDEBAR_COLLAPSED_KEY) === 'true';
    } catch {
        return false;
    }
}

function AppLayoutContainer() {

  const navigate = useNavigate()
  const location = useLocation();
  const [isLoginExist, setIsLoginExist] = useState(true);
    const [role, setRole] = useState(sessionStorage.getItem('role'));
    const [collapsed, setCollapsed] = useState(readCollapsed);
    const [mobileOpen, setMobileOpen] = useState(false);

    useEffect(() => {
        const authTokenDetail = sessionStorage.getItem('loginToken');
   if (authTokenDetail) {
      // Update the state using setState
      setIsLoginExist(true);
    }
    else {
      navigate('/login')
    }
  }, []);

    useEffect(() => {
        try {
            localStorage.setItem(SIDEBAR_COLLAPSED_KEY, String(collapsed));
        } catch {
            // storage unavailable (private mode etc.) - preference just isn't remembered
        }
    }, [collapsed]);

    // Close the mobile drawer whenever the route changes
    useEffect(() => {
        setMobileOpen(false);
    }, [location.pathname]);

    useEffect(() => {
        if (!mobileOpen) return undefined;
        const onKeyDown = (e) => {
            if (e.key === 'Escape') setMobileOpen(false);
        };
        document.addEventListener('keydown', onKeyDown);
        return () => document.removeEventListener('keydown', onKeyDown);
    }, [mobileOpen]);

    const toggleSidebar = useCallback(() => {
        if (window.matchMedia(MOBILE_QUERY).matches) {
            setMobileOpen(open => !open);
        } else {
            setCollapsed(c => !c);
        }
    }, []);

    const closeMobileSidebar = useCallback(() => setMobileOpen(false), []);

    const wrapperClass = [
        'page-wraper',
        collapsed ? 'sidebar-collapsed' : '',
        mobileOpen ? 'sidebar-mobile-open' : ''
    ].filter(Boolean).join(' ');

  return (
    <>
      <div className={wrapperClass}>
        <AppHeader isLoginExist={isLoginExist} onToggleSidebar={toggleSidebar} sidebarExpanded={mobileOpen || !collapsed} />
        {isLoginExist ? (
          <>
            <AppSidebar collapsed={collapsed} onNavigate={closeMobileSidebar} />
            <div className="sidebar-backdrop" onClick={closeMobileSidebar} aria-hidden="true" />
            <div id="content">
              <div className="content-admin-main">
                <Outlet />
              </div>
            </div>
          </>
        ) : (
          <AppLogin />
        )}
      </div>
    </>
  );
}

export default AppLayoutContainer;
